import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {useWorkflowQuery} from 'api';
import {Button} from 'components/antd';
import ContactField from './ContactField';
import ContactSelectOption from './ContactSelectOption';
import Close from './Close';
import useClientUser from 'hooks/useClientUser';

type SelectSearchCondition = {
  field_select_option_id: string;
  field_type: string;
  contact_field_id: string;
};

type Props = {
  salesforceContactSearchConditions: SelectSearchCondition[];
  setSalesforceContactSearchConditions: React.Dispatch<
    React.SetStateAction<SelectSearchCondition[]>
  >;
};

export default ({
  salesforceContactSearchConditions,
  setSalesforceContactSearchConditions,
}: Props) => {
  const {isMember} = useClientUser();
  const {workflowId} = useParams<{poolId: string; workflowId: string}>();

  const {data: {workflow = {}, workflow: {searchCondition = {}} = {}} = {}} =
    useWorkflowQuery({
      variables: {uuid: workflowId},
    });

  const isConditionUpdatable = React.useMemo(
    () => workflow?.status === 'draft',
    [workflow],
  );

  return (
    <>
      <div className="flex mt-2">
        <Label>条件項目</Label>
        <div className="flex flex-col gap-1">
          {salesforceContactSearchConditions?.map(
            (condition: SelectSearchCondition, index: number) => {
              return (
                <div className="flex" key={index}>
                  <ContactField condition={condition} />
                  <ContactSelectOption condition={condition} />
                  {isConditionUpdatable && isMember && (
                    <Close
                      setSalesforceContactSearchConditions={
                        setSalesforceContactSearchConditions
                      }
                      salesforceContactSearchConditions={
                        salesforceContactSearchConditions
                      }
                      index={index}
                    />
                  )}
                </div>
              );
            },
          )}
          <AddButton
            disabled={
              !searchCondition.salesforceContactRecordTypeId ||
              !isConditionUpdatable ||
              !isMember
            }
            onClick={() =>
              setSalesforceContactSearchConditions([
                ...salesforceContactSearchConditions,
                {} as SelectSearchCondition,
              ])
            }>
            + 条件を追加
          </AddButton>
        </div>
      </div>
    </>
  );
};

const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  letter-spacing: 0.15px;
  color: var(--text-color-1);
  padding-right: 8px;
  width: 110px;
`;

const AddButton = styled(Button)`
  margin-top: 10px;
  width: 110px;
`;
